<app-card>
    <ng-template #header>
        <div class="flex justify-content-between align-items-center gap-small small-buttons">
            <div class="textSubheader font-bold flex-1">
                {{ 'workData.common.enum.type.operationalReport' | translate }}
            </div>
            <app-check-input
                class="justify-self-end"
                [form]="form"
                id="sendEmail"
                label="common.sendEmail"
            ></app-check-input>
        </div>
    </ng-template>

    <ng-template #content>
        <div class="contentGrid input-grid-gaps">
            <app-service-pattern-wysiwyg
                class="fr-3"
                [form]="form"
                [height]="200"
                id="description"
                editorKey="WorkOperationalReportDescriptionWidget"
                [serviceId]="serviceId()"
                [usage]="ServicePatternStructureUsageEnum.INDIVIDUAL_WORK_NOTIFY_OPERATIONAL_RECORD"
                (addedPattern)="formAddText(form, 'description', $event.content)"
            ></app-service-pattern-wysiwyg>

            <app-select-input
                [form]="form"
                id="type"
                label="service.operationalReport.fields.type"
                [staticOptions]="serviceOperationalReportTypeEnumOptions"
                [valueKey]="'value'"
            ></app-select-input>
            <app-select-input
                [form]="form"
                id="priority"
                label="service.operationalReport.fields.priority"
                [staticOptions]="serviceOperationalReportPriorityEnumOptions"
                [valueKey]="'value'"
            ></app-select-input>

            <app-input-user-multiselect
                id="userIds"
                [form]="form"
                label="service.operationalReport.fields.workers"
                [serviceId]="serviceId()"
            ></app-input-user-multiselect>
        </div>
    </ng-template>
</app-card>
